<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  modelValue: boolean
  calculationName?: string
  loading?: boolean
}>()

const emit = defineEmits<{
  'update:modelValue': [value: boolean]
  confirm: []
}>()

const dialog = computed({
  get: () => props.modelValue,
  set: (value: boolean) => emit('update:modelValue', value)
})

const close = () => {
  if (props.loading) return
  dialog.value = false
}

const confirm = () => {
  emit('confirm')
}
</script>

<template>
  <v-dialog v-model="dialog" max-width="520" @click:outside="close">
    <v-card class="pa-3">
      <v-card-title>Stop calculation</v-card-title>

      <v-card-text>
        <p class="mb-3">
          Are you sure you want to stop {{ calculationName || 'this calculation' }}?
        </p>
        <p class="mb-0">
          This deletes the active Azure compute resource, but keeps the calculation, uploaded input,
          output files, logs, and collected metrics. The calculation will become Cancelled and can
          be rescheduled later.
        </p>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn class="text-none" color="primary" :disabled="loading" @click="close">Cancel</v-btn>
        <v-btn
          class="text-none"
          color="error"
          variant="tonal"
          prepend-icon="mdi-stop-circle-outline"
          :loading="loading"
          :disabled="loading"
          @click="confirm"
        >
          Stop calculation
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
